import React from 'react';
import PropTypes from 'prop-types';
import uuid from '@cotyorg/ccx-utils/js/helpers/uuid';
import ProductDetailsTabContent from '../../ProductDetailsTabContent';
import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody,
} from '../../../Accordion';

/**
 * @visibleName Product Details -- Accordion variation
 */

const ProductDetailsAccordion = ({
  productDetails,
  isFullWidth,
  minusIconSrc,
  plusIconSrc,
  style = 'icons',
  iconWidth = 16,
  iconHeight,
  isOpen,
}) => (
  <div className="product-details-accordion">
    <Accordion isOpen={isOpen}>
      {Array.isArray(productDetails.tabs) &&
        productDetails.tabs
          .filter(({ content }) => content)
          .map(({
 title, content, details, isOpen: isSectionOpen,
}) => (
  <AccordionItem key={uuid()} isOpen={isSectionOpen}>
    <AccordionItemTitle
      minusIconSrc={minusIconSrc}
      plusIconSrc={plusIconSrc}
      buttonExtraClass="product-details__accordion-button"
      iconWidth={iconWidth}
      iconHeight={iconHeight}
    >
      {title}
    </AccordionItemTitle>
    <AccordionItemBody contentExtraClassNames="product-details__accordion-content">
      <ProductDetailsTabContent
        content={content}
        details={details}
        style={style}
        isFullWidth={isFullWidth}
      />
    </AccordionItemBody>
  </AccordionItem>
          ))}
    </Accordion>
  </div>
);

ProductDetailsAccordion.propTypes = {
  productDetails: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string,
    details: PropTypes.arrayOf(PropTypes.shape({
      icon: PropTypes.string,
      text: PropTypes.string,
    })),
  }).isRequired,
  style: PropTypes.oneOf(['icons', 'bullets']),
  isFullWidth: PropTypes.bool,
  minusIconSrc: PropTypes.string,
  plusIconSrc: PropTypes.string,
  iconWidth: PropTypes.number,
  iconHeight: PropTypes.number,
  isOpen: PropTypes.bool,
};

export default ProductDetailsAccordion;
